import { GetPageResponse } from "@store/features/crm/pageV2Slice";
import { DataType } from "skedyul-db/browser";
import dayjs from "dayjs";
import {
  AU_DATE_FORMAT,
  AU_DATETIME_FORMAT,
  AU_TIME_FORMAT,
} from "skedyul-ui/ui";
import { Params } from "../../helpers";
import { getByPath } from "./utils";

export const createDatePickerCell = (
  fieldType: "DATE" | "DATE_TIME" | "TIME",
  isSystemField: boolean,
  _params: Params,
  accessorPath: string,
  _pageData?: GetPageResponse,
) => {
  // If this is a system field, render NonEditable with a label when present, em dash otherwise
  if (isSystemField) {
    return {
      component: "NonEditable" as const,
      generateProps: (
        row: Record<string, unknown>,
        _index: number,
        _originalRow?: Record<string, unknown>,
      ) => {
        const raw = getByPath(row, accessorPath);
        let label: string | undefined = undefined;
        if (raw !== undefined && raw !== null && String(raw).trim() !== "") {
          if (fieldType === DataType.TIME) {
            const parsed = dayjs(`1970-01-01T${String(raw)}`);
            label = parsed.isValid() ? parsed.format(AU_TIME_FORMAT) : String(raw);
          } else if (fieldType === DataType.DATE) {
            const parsed = dayjs(String(raw));
            label = parsed.isValid() ? parsed.format(AU_DATE_FORMAT) : String(raw);
          } else {
            const parsed = dayjs(String(raw));
            label = parsed.isValid()
              ? parsed.format(AU_DATETIME_FORMAT)
              : String(raw);
          }
        }
        return { label };
      },
    };
  }

  if (fieldType === DataType.TIME) {
    return {
      component: "DatePicker" as const,
      generateProps: (
        row: Record<string, unknown>,
        _index: number,
        originalRow?: Record<string, unknown>,
      ) => ({
        id: accessorPath,
        value: getByPath(row, accessorPath)
          ? new Date(`1970-01-01T${getByPath(row, accessorPath) as string}`)
          : undefined,
        originalValue:
          originalRow && getByPath(originalRow, accessorPath)
            ? new Date(
                `1970-01-01T${getByPath(originalRow, accessorPath) as string}`,
              )
            : undefined,
        mode: "time" as const,
        labelFormat: AU_TIME_FORMAT,
        placeholder: `Select ${accessorPath}`,
        handleChange: (_date: Date | undefined) => {
          /* no-op */
        },
      }),
    };
  }
  return {
    component: "DatePicker" as const,
    generateProps: (
      row: Record<string, unknown>,
      _index: number,
      originalRow?: Record<string, unknown>,
    ) => ({
      id: accessorPath,
      value: getByPath(row, accessorPath)
        ? new Date(getByPath(row, accessorPath) as string)
        : undefined,
      originalValue:
        originalRow && getByPath(originalRow, accessorPath)
          ? new Date(getByPath(originalRow, accessorPath) as string)
          : undefined,
      mode:
        fieldType === DataType.DATE
          ? ("date" as const)
          : ("date-time" as const),
      labelFormat:
        fieldType === DataType.DATE ? AU_DATE_FORMAT : AU_DATETIME_FORMAT,
      placeholder: `Select ${accessorPath}`,
      handleChange: (_date: Date | undefined) => {
        /* no-op */
      },
    }),
  };
};
